import { useEffect } from 'react';

// react-use has a useKey, which is better than this, but avoiding overloading
// this lib with other libs to maintain download performance.

export function useKey(key: string, callback: (event: KeyboardEvent) => void) {
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === key) {
        callback(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [callback]);
}
